import { render, staticRenderFns } from "./PeriodDuration.vue?vue&type=template&id=f6795f5e&scoped=true&"
import script from "./PeriodDuration.vue?vue&type=script&lang=js&"
export * from "./PeriodDuration.vue?vue&type=script&lang=js&"
import style0 from "./PeriodDuration.vue?vue&type=style&index=0&id=f6795f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6795f5e",
  null
  
)

export default component.exports